import { Box, Chip, Divider } from '@mui/material';
import React from 'react';
export const FilterChips = ({ valueApplied, chipLabelsApplied }) => {
    let chipLabelsToRender = [];
    Object.keys(valueApplied.value).forEach((key) => {
        if (chipLabelsApplied[key]) {
            chipLabelsToRender = [...chipLabelsToRender, ...chipLabelsApplied[key]];
        }
    });
    if (chipLabelsToRender.length === 0) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { sx: { display: 'flex', flexWrap: 'wrap', px: 2, pt: 1, pb: 2, gap: 1 }, "data-test": 'filter-chips' }, chipLabelsToRender.map((chipLabel, index) => {
            return React.createElement(Chip, { key: index, label: chipLabel, "data-test": `chip-${index}` });
        })),
        React.createElement(Divider, null)));
};
